/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */

/// <summary>
/// セレクトボックスの要素データ
/// </summary>
export class SelectBoxItemData
{
    // ID
    id = "";

    // ラベル
    label = "";
}

/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */
